/**
 * Route Widget Icon & Description Customization
 *
 * Replaces the circular info icon with a rounded-square variant and
 * removes the trailing period from the coverage description text.
 * Handles multiple widget instances and re-renders via MutationObserver.
 */
(function() {

  // Swap circle SVG path for a rounded-rect + text-based icon
  function transformIcon(icon) {
    icon.setAttribute('data-icon-transformed', 'true');
    icon.setAttribute('viewBox', '0 0 20 20');
    icon.innerHTML = `
      <rect x="1.25" 
            y="1.25" 
            width="17.5" 
            height="17.5" 
            rx="3.5" 
            ry="3.5"
            stroke="#3f3e3e" 
            stroke-width="1.25" 
            fill="none"/>
      <text
        x="10"
        y="14.5"
        text-anchor="middle"
        font-family="Trebuchet MS, sans-serif"
        font-size="13"
        fill="#3f3e3e"
        font-weight="400"
      >i</text>
    `;
  }

  // Strip trailing period from description text
  function transformDescription(el) {
    el.setAttribute('data-description-transformed', 'true');
    el.textContent = el.textContent.replace(/\.\s*$/, '');
  }

  // :not() guards prevent re-processing already-transformed elements
  function processAll() {
    document.querySelectorAll('.pw-button-reset.pw-info-icon > svg:not([data-icon-transformed])')
      .forEach(transformIcon);
    document.querySelectorAll('.pw-coverage-description:not([data-description-transformed])')
      .forEach(transformDescription);
  }

  processAll();

  // Re-run on any DOM additions (widget appear/disappear cycles, multiple instances)
  const observer = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        processAll();
        return;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();